/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import ReactJson from 'react-json-view';
import { useAppSelector } from '../_store/hooks';
import { selectShowJson } from '@/_store/modules/layout/selectors';

// import { Container } from './styles';

interface IJsonView {
  name: string;
  source: any;
  collapsed?: boolean;
  show?: boolean;
}

const JsonView: React.FC<React.PropsWithChildren<IJsonView>> = ({
  name,
  source,
  collapsed = true,
  show,
}) => {
  const showJson = useAppSelector(selectShowJson);

  if (!showJson && !show) return null;

  return (
    <div className="json-view-container">
      <ReactJson
        src={source}
        theme="monokai"
        collapsed={collapsed}
        name={name}
        style={{ borderRadius: 8, padding: 8 }}
      />
    </div>
  );
};

export default JsonView;
